import Reflux from "reflux";

const SelectionActions = Reflux.createActions(["setDragSelecting", "toggleStageSelectLayer"]);

export default SelectionActions;
